export const AUTH_KEYS = [
  "token",
  "access_token",
  "ava_token",
  "ava_session_token",
  "authToken",
  "jwt",
];

export function getUnifiedToken(): string {
  try {
    for (const key of AUTH_KEYS) {
      const local = localStorage.getItem(key);
      if (local && local.trim()) return local.trim();

      const session = sessionStorage.getItem(key);
      if (session && session.trim()) return session.trim();
    }

    return "";
  } catch {
    return "";
  }
}

export function clearAllAuthState() {
  try {
    for (const key of AUTH_KEYS) {
      try { localStorage.removeItem(key); } catch {}
      try { sessionStorage.removeItem(key); } catch {}
    }

    const extra = [
      "auth_user",
      "ava_user",
      "user",
      "profile",
      "ava_profile",
      "user_profile",
      "ava_chat_plan",
      "ava_user_role",
      "ava_logged_out",
      "ava_auth_me_cache_v1",
    ];

    for (const key of extra) {
      try { localStorage.removeItem(key); } catch {}
      try { sessionStorage.removeItem(key); } catch {}
    }
  } catch {}
}
